import { render, staticRenderFns } from "./search_.vue?vue&type=template&id=28251dc3&scoped=true&"
import script from "./search_.vue?vue&type=script&lang=js&"
export * from "./search_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28251dc3",
  null
  
)

export default component.exports